import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import { createContext } from "react";

const BrazilianCompanyContext = createContext<IBrazilianCompanyIssuerTopLevelFragment | null>(null);

export default BrazilianCompanyContext;
